/* eslint-disable import/prefer-default-export */

import { Native, env } from '@hb/NBridge/lib/h5';
import pkg from '../../package.json';

const _env = null;

export const getEnv = ({ userAgent, refresh = false } = {}) => {
  if (_env && !refresh) {
    return _env;
  }
  const ua = userAgent || window.navigator.userAgent;
  return {
    isIOS: /iPad|iPhone|iPod/i.test(ua),
    isAndroid: /android/i.test(ua),
    isEasyBikeApp: !!ua.match(/\b\s*app=easybike(?:;\s*version=([\d.]+))*/i),
    isAliMPMonitor: /AlipayClient/.test(ua) && /AlipayIDE/.test(ua),
    isAliMP: /AlipayClient/.test(ua) && /MiniProgram/.test(ua),
    isWechatMP: ua.indexOf('miniProgram') > -1 || window.__wxjs_environment === 'miniprogram',
    isDouyinMP: ua.toLowerCase().includes('toutiaomicroapp'),
    isHarmony: /OpenHarmony/i.test(ua),
  };
};

export const getSystemCode = () => {
  const e = getEnv();
  if (e.isIOS && e.isEasyBikeApp) {
    return 61;
  }
  if (e.isAndroid && e.isEasyBikeApp) {
    return 62;
  }
  if (e.isAliMP || e.isAliMPMonitor) {
    return 65;
  }
  if (e.isWechatMP) {
    return 64;
  }
  if (e.isDouyinMP) {
    return 69;
  }
  return 63;
};

export const getVersion = async () => {
  const e = getEnv();
  if (e.isAliMP || e.isAliMPMonitor) {
    const { alissVersion } = await Native.callNative({
      method: 'getSystemInfo',
      params: {},
    }).then((v) => v || {}).catch(() => ({}));
    return alissVersion || '';
  }
  if (e.isEasyBikeApp) {
    return env.appVersion || '';
  }
  return pkg.version;
};
